import core from '@js/core';
import cover from '@ui/cover/index';
import checkbox from '@ui/checkbox';
import radioButton from '@ui/radio-button';
import tabsBox from '@ui/tabs-box';
import matchBar from '@ui/match-bar';
import matchCalendar from '@ui/matchCalendar/index';
import commentsHome from '@ui/comments/home/index';
import slidingBox from '@ui/sliding-box';
import poll from '@ui/poll/index';

const ui = [matchCalendar, cover, checkbox, radioButton, slidingBox, commentsHome, tabsBox, matchBar, poll];

core.register(ui);



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/views/homepage.js